import { createContext, useState } from 'react';
import type { OrderDetails, TimelineDetail } from '../types/order';

export const TransferDetailsContext = createContext({});

const TransferDetailsContextProvider = ({ children }) => {
	const [orderId, setOrderId] = useState<string>('');
	const [expires, setExpires] = useState<string>('');
	const [details, setDetails] = useState<OrderDetails | null>(null);
	const [timeline, setTimeline] = useState<TimelineDetail[] | null>(null);
	const [statusRefreshedAt, setStatusRefreshedAt] = useState<Date | null>(null);

	const contextProps = {
		orderId,
		setOrderId,
		expires,
		setExpires,
		details,
		setDetails,
		timeline,
		setTimeline,
		statusRefreshedAt,
		setStatusRefreshedAt
	};

	return <TransferDetailsContext.Provider value={contextProps}>{children}</TransferDetailsContext.Provider>;
};

export default TransferDetailsContextProvider;
